import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../annuaire/designSystem';
import { slugify } from '../../utils/utils';

const BreadcrumbWrapper = styled.div`
  background-color: ${colors.bleuPastel};
  padding: 16px 0;
  font-size: 0.85rem;
  font-family: ${fonts.body};
`;

const BreadcrumbNav = styled.nav`
  max-width: 1060px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;

  @media (min-width: 768px) {
    padding: 0 32px;
  }
`;

const BreadcrumbLink = styled.a`
  color: ${colors.bleu};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.bleuFonce};
  }
`;

const BreadcrumbCurrent = styled.span`
  color: ${colors.textDark};
  font-weight: 600;
`;

const Separator = styled.span`
  color: ${colors.textSecondary};
  margin: 0 0.25rem;
`;

export default function ShopBreadcrumb({ shop }) {
  const details = shop.details || {};
  const ville = shop.city || '';
  const nom = shop.name || '';

  const villeSlug = slugify(ville);
  const urlPath = shop.url_path || '';
  const deptSlug = urlPath.split('/')[0] || '';
  const cityHref = deptSlug
    ? `/annuaire-velo/${deptSlug}/${villeSlug}`
    : `/annuaire-velo/${villeSlug}`;

  return (
    <BreadcrumbWrapper>
      <BreadcrumbNav aria-label="breadcrumb">
        <BreadcrumbLink href="/">Accueil</BreadcrumbLink>
        <Separator>/</Separator>
        <BreadcrumbLink href="/annuaire-velo">Annuaire</BreadcrumbLink>
        {ville && (
          <>
            <Separator>/</Separator>
            <BreadcrumbLink href={cityHref}>{ville}</BreadcrumbLink>
          </>
        )}
        <Separator>/</Separator>
        <BreadcrumbCurrent>{nom}</BreadcrumbCurrent>
      </BreadcrumbNav>
    </BreadcrumbWrapper>
  );
}
